export default class Reset{
    constructor(kv){

        this.kv = kv;

    }

    /* ---------------------------------------------------

     -- 全体の初期化

    --------------------------------------------------- */

    set(){

        TweenMax.set([this.kv.detailContent[this.kv.status.index].querySelectorAll('.fake-image')[0],this.kv.detailContent[this.kv.status.index].querySelectorAll('.fake-image')[1],this.kv.detailContent[this.kv.status.index].querySelectorAll('.image')], {
            display:'none',
            opacity:0
        });

        // for(let i=0; this.kv.detail.children.length>i; i++) {
        //     TweenMax.set([this.kv.detailNumber[i].children,this.kv.detailEn[i].children,this.kv.detailJp[i].children], {
        //         y: '100%',
        //     });
        //     TweenMax.set([this.kv.detailText[i]], {
        //         opacity: 0,
        //         y: '50px',
        //     });
        // }

    }


}